// extracted by mini-css-extract-plugin
export var dropdownButton = "_3c-0";
export var fullWidthDropdownButton = "_3c-1";
export var icon = "_3c-3";
export var iconPlaceholder = "_3c-2";
export var shortcutContainer = "_3c-4";